
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/responsys",
      function () {
        return require("private-next-pages/destinations/responsys.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/responsys"])
      });
    }
  